module.exports = __webpack_public_path__ + "img/Group-10.64d9bb46.png";